import {createSlice} from "@reduxjs/toolkit";

const initialBranchesState = {
    listLoading: false,
    actionsLoading: false,
    totalCount: 0,
    entities: null,
    branchForEdit: undefined,
    lastError: null
};

export const callTypes = {
    list: "list",
    action: "action"
}

export const branchesSlice = createSlice({
    name: "branches",
    initialState: initialBranchesState,
    reducers: {
        catchError: (state, action) => {
            state.error = `${action.type}: ${action.payload.error}`;
            if (action.payload.callType === callTypes.list) {
                state.listLoading = false;
            } else {
                state.actionsLoading = false;
            }
        },
        startCall: (state, action) => {
            state.error = null;
            if (action.payload.callType === callTypes.list) {
                state.listLoading = true;
            } else {
                state.actionsLoading = true;
            }
        },
        // getBranchById
        branchFetched: (state, action) =>{
            state.actionsLoading = false;
            state.branchForEdit = action.payload.branchForEdit;
            state.error = null;
        },
        // findBranches / getAllBranches
        branchesFetched: (state, action) =>{
            const {totalCount, entities} = action.payload;
            state.listLoading = false;
            state.error = null;
            state.entities = entities;
            state.totalCount = totalCount;
        },
        
        branchCreated: (state, action) =>{
          state.actionsLoading = false;
          state.error = null;
          state.entities.push(action.payload.branch);
        },
        
        // updateBranch
        branchUpdated: (state, action) =>{
            state.error = null;
            state.actionsLoading = false;
            state.entities = state.entities.map(entity =>{
                if(entity.id === action.payload.branch.id){
                    return action.payload.branch;
                }
                return entity;
            })
        },
        //deleteBranch
        branchDeleted: (state, action) =>{
            state.error = null;
            state.actionsLoading = false;
            state.entities = state.entities.filter(el => el.id !== action.payload.id);
        },
        branchToggled: (state, action) =>{
            state.error = null;
            state.actionsLoading = false;
        }
    }
})